<template>
    <div>
        <Button :id="'edit-button'" :type="'primary'" title="Rehab Targets" v-b-modal.edit-rehab-edit-modal
                :onClick="showModal" />
        <EditModal v-if="distanceBands && rehabTargets" id="edit-rehab-edit-modal" title="Rehab Targets"
            :ok="saveRehabTargets" :showModal="showModalDialog" :cancel="hideModal" size="xl" :okDisabled="disableOkButton"
            cancelVariant="secondary standard-btn">
            <div class="alert alert-danger" v-if="disableOkButton">
                <p>Some fields have invalid values. Please check and correct them.</p>
            </div>
            <div class="form-group container">
                <div class="row justify-content-center">
                    <label class="col-3 align-self-center" for="edit-type">Distance (<MeasurementUnit :type="LongDistance" />)</label>
                    <b-form-input class="col-1 align-self-center" v-model="distanceM" required></b-form-input>
                    <div class="col-1" />
                    <label class="col-3 align-self-center" for="edit-type">HSR Distance (<MeasurementUnit :type="ShortDistance" />)</label>
                    <b-form-input class="col-1 align-self-center" v-model="hsrDistanceM"></b-form-input>
                </div>

                <div class="row justify-content-center">
                    <label class="col-3 align-self-center" for="edit-type">Sprint Distance (<MeasurementUnit :type="ShortDistance" />)</label>
                    <b-form-input class="col-1 align-self-center" v-model="sprintDistanceM" required></b-form-input>
                    <div class="col-1" />
                    <label class="col-3 align-self-center" for="edit-type">Turns</label>
                    <b-form-input class="col-1 align-self-center" v-model="turns" required></b-form-input>
                </div>

                <div class="row justify-content-center">
                    <label class="col-3 align-self-center" for="edit-type">Acceleration Distance (<MeasurementUnit :type="ShortDistance" />)</label>
                    <b-form-input class="col-1 align-self-center" v-model="accelerationDistanceM" required></b-form-input>
                    <div class="col-1" />
                    <label class="col-3 align-self-center" for="edit-type">Deceleration Distance (<MeasurementUnit :type="ShortDistance" />)</label>
                    <b-form-input class="col-1 align-self-center" v-model="decelerationDistanceM" required></b-form-input>
                </div>


                <div class="row justify-content-center">
                    <label class="col-3 align-self-center" for="edit-type">Peak Speed (<MeasurementUnit :type="PeakSpeed" />)</label>
                    <b-form-input class="col-1 align-self-center" v-model="peakSpeedMPerS"></b-form-input>
                    <div class="col-1" />

                    <div class="col-4" />
                </div>

                <div class="row justify-content-center mt-4">
                    <div class="col-1"></div>
                    <div v-for="d in sortDistanceBands(distanceBands)" :key="d.value" class="col-2 align-self-end">
                        {{ formatDistanceBandTitle(d).text }}
                    </div>
                </div>
                <div class="row justify-content-center" v-if="sprintCountTargets">
                    <div class="col-1 align-self-center">HSR</div>
                    <div v-for="d in sortDistanceBands(distanceBands)" :key="d.value" class="col-2" >
                        <b-form-input v-model="sprintCountTargets.HSR[d.id]" required></b-form-input>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="sprintCountTargets">
                    <div class="col-1 align-self-center">Sprint</div>
                    <div v-for="d in sortDistanceBands(distanceBands)" :key="d.value" class="col-2" >
                        <b-form-input v-model="sprintCountTargets.SPRINT[d.id]" required></b-form-input>
                    </div>
                </div>
                
                <div class="row mt-1" >
                    <Button v-if="hasTargetsReferences" :id="'average-button'" :type="'secondary'"
                            :title="'Populate with Averages'" :onClick="populateAverageTargets" />
                    <Button v-if="hasTargetsReferences" :id="'max-button'" :type="'secondary'"
                            :title="'Populate with Maximums'" :onClick="populateMaximumTargets" />
                </div>
            </div>
        </EditModal>
    </div>
    
</template>
<script>
import EditModal from "@/components/EditModal.vue";
import Button from "@/components/Button.vue";
import MeasurementUnit from "@/components/MeasurementUnit.vue";
import { MeasurementTypes, getMeasurementUnit } from "@/utils/MeasurementSystem";
import { formatDistanceBandTitle, sortDistanceBands } from "@/utils/SpeedBandsHelper";
import { errorHandler } from "@/components/ErrorHandler";

export default {
    components: {
        Button,
        EditModal, MeasurementUnit,
    },
    data() {
        return {
            ShortDistance: MeasurementTypes.ShortDistance,
            LongDistance: MeasurementTypes.LongDistance,
            PeakSpeed: MeasurementTypes.PeakSpeed,
            sdUnit: getMeasurementUnit(MeasurementTypes.ShortDistance),
            ldUnit: getMeasurementUnit(MeasurementTypes.LongDistance),
            peakSpeed: getMeasurementUnit(MeasurementTypes.PeakSpeed),
            countUnit: getMeasurementUnit(MeasurementTypes.Count),
            showModalDialog: false,
            hasTargetsReferences: true,
            sprintCountTargets: {
                HSR: {},
                SPRINT: {},
            },
            distanceM: null,
            hsrDistanceM: null,
            sprintDistanceM: null,
            accelerationDistanceM: null,
            decelerationDistanceM: null,
            turns: null,
            peakSpeedMPerS: null,
        };
    },
    props: {
        customerId: String,
        playerId: String,
        rehabTargets: Object,
        distanceBands: Array,
        refreshData: Function,
        targetReferences: Object
    },
    methods: {
        async saveRehabTargets() {
            this.rehabTargets.sprintCountTargets = this.sprintCountTargets;
            const distanceM = this.ldUnit.reverseConvert(this.distanceM);
            const peakSpeedMPerS = this.peakSpeed.reverseConvert(this.peakSpeedMPerS);
            const hsrDistanceM = this.sdUnit.reverseConvert(this.hsrDistanceM);
            const sprintDistanceM = this.sdUnit.reverseConvert(this.sprintDistanceM);
            const accelerationDistanceM = this.sdUnit.reverseConvert(this.accelerationDistanceM);
            const decelerationDistanceM = this.sdUnit.reverseConvert(this.decelerationDistanceM);

            const json = {
                distanceM, hsrDistanceM, sprintDistanceM,
                accelerationDistanceM, decelerationDistanceM,
                turns: Number(this.turns), peakSpeedMPerS,
                sprintCountTargets: this.sprintCountTargets
            };
            const response = await this.$root.webApiPost(
                `/setrehabtargets?customerId=${this.customerId}&playerId=${this.playerId}`,
                json
            );
            if (response.status === 200) {
                await this.refreshData();
                this.hideModal();
            } else {
                errorHandler.error(response, this);
            }
        },
        showModal() {
            //Populate the fields with target values 
            this.populateTargets(this.rehabTargets.rehabKpiValues);
            this.populateSprintCountTargets(this.rehabTargets.sprintCountTargets);
            this.showModalDialog = true;
        },
        hideModal() {
            this.showModalDialog = false;
        },
        populateAverageTargets() {
            this.populateTargets(this.targetReferences.avgKpis);
            this.populateSprintCountTargets(this.targetReferences.sprintCounts, 'average');
        },
        populateMaximumTargets() {
            this.populateTargets(this.targetReferences.maxKpis);
            this.populateSprintCountTargets(this.targetReferences.sprintCounts, 'maximum');
        },
        populateTargets({ ACCEL, DECEL, DISTANCE, HSR, PEAK_SPEED, SPRINT, TURNS }) {
            const getKpi = (val, unit) => val !== null ? unit.formatFine(val) : null;
            this.distanceM = getKpi(DISTANCE, this.ldUnit);
            this.peakSpeedMPerS = getKpi(PEAK_SPEED, this.peakSpeed);
            this.hsrDistanceM = getKpi(HSR, this.sdUnit);
            this.sprintDistanceM = getKpi(SPRINT, this.sdUnit);
            this.accelerationDistanceM = getKpi(ACCEL, this.sdUnit);
            this.decelerationDistanceM = getKpi(DECEL, this.sdUnit);
            this.turns = TURNS !== null ? this.countUnit.formatFine(TURNS) : null;
        },
        formatDistanceBandTitle,
        sortDistanceBands,
        populateSprintCountTargets(source, key = null) {
            this.sprintCountTargets = {
                HSR: {},
                SPRINT: {},
            };
            ['HSR', 'SPRINT'].forEach(speedType => {
                this.sprintCountTargets[speedType] = {};
                this.distanceBands.forEach(distanceBand => {
                    const bandId = distanceBand.id;
                    const bandData = source?.[speedType]?.[bandId];
                    // Using this.$set here to ensure Vue 2 reactivity is preserved when adding new nested keys.
                    // Direct assignment (e.g., this.sprintCountTargets.HSR[bandId] = ...) would not be reactive if the key didn't previously exist on the object.
                    let valueToSet = null;

                    if (bandData) {
                        const hasKey = key && bandData[key];
                        if (hasKey) {
                            valueToSet = key === 'average' ? this.countUnit.formatFine(bandData[key]) : bandData[key];
                        } else {
                            valueToSet = bandData;
                        }
                    }
                    this.$set(this.sprintCountTargets[speedType], bandId, valueToSet);

                });
            });
        }
    },
    computed: {
        disableOkButton() {
            const isInvalidInput = field => (typeof field === 'string' && isNaN(field));

            const kpiValues = [
                this.distanceM,
                this.hsrDistanceM,
                this.sprintDistanceM,
                this.accelerationDistanceM,
                this.decelerationDistanceM,
                this.turns,
                this.peakSpeedMPerS
            ];

            const sprintValues = Object.values(this.sprintCountTargets.SPRINT || {});
            const hsrValues = Object.values(this.sprintCountTargets.HSR || {});

            return [...kpiValues, ...sprintValues, ...hsrValues].some(isInvalidInput);
        }
    }
};
</script>